export const registerStaffApi = {
  ADD_REGISTER_STAFF: '/api/fair/member/exhibitor-staff',
  GET_REGISTER_STAFF: '/api/fair/member/exhibitor-staff',
};
